/* Keep native server-rendered product blocks intact for quick view and no-JS use. */
(function () {
  'use strict';

  var selector = '[data-emz-hybrid-product="true"]';
  var states = new WeakMap();
  var INSIDE_LIMIT = 6;
  var INSIDE_WAIT = 8000;
  var STYLE_ID = 'emz-hybrid-product-story-styles';

  // Styles for structure this script creates ship with it, so nothing flashes unstyled
  // while a separate stylesheet loads. Selectors match the specificity of the
  // emz-hybrid.css rules they extend; this element is appended after them.
  var STYLES = [
    '.emz-hybrid #MainContent .emz-hybrid-product-ready .emz-hybrid-product-grid { grid-template-areas: "media intro" "media lede" "media details"; grid-template-rows: auto auto 1fr; }',
    '.emz-hybrid #MainContent .emz-hybrid-product-ready .emz-hybrid-product-grid[data-emz-image-position=right] { grid-template-areas: "intro media" "lede media" "details media"; }',
    '.emz-hybrid #MainContent .emz-hybrid-product-ready .emz-hybrid-product-grid > .emz-hybrid-product-lede { grid-area: lede; display: grid; grid-template-columns: minmax(0,1fr) auto; column-gap: 0; align-items: start; width: auto !important; min-width: 0; max-width: none; padding: 0 !important; float: none; order: 0 !important; overflow-wrap: anywhere; }',
    '.emz-hybrid .emz-hybrid-product-lede > * { grid-column: 1 / -1; min-width: 0; }',
    '.emz-hybrid .emz-hybrid-product-lede > .product-block--price { grid-column: 1; grid-row: span 2; margin-bottom: 20px; }',
    '.emz-hybrid #PageContainer .emz-hybrid-product-lede .product__price { font-size: 26px !important; }',
    /* small--text-center would centre the native policy line inside the narrower price column. */
    '.emz-hybrid .emz-hybrid-product-lede > .product-block--price .product__policies { text-align: start !important; }',
    '.emz-hybrid .emz-hybrid-product-lede > .emz-save-control--product:not([hidden]) { display: contents; }',
    '.emz-hybrid .emz-hybrid-product-lede > .emz-save-control--product > :is([data-saved-toggle],[data-saved-view]) { grid-column: 2; justify-self: end; margin-inline-start: 16px; }',
    '.emz-hybrid .emz-hybrid-product-lede > .emz-save-control--product > [data-saved-feedback] { grid-column: 1 / -1; margin: -8px 0 16px; }',
    '@media (max-width: 768px) { .emz-hybrid #MainContent .emz-hybrid-product-ready .emz-hybrid-product-grid[data-emz-image-position] { grid-template-areas: "intro" "media" "lede" "details"; grid-template-rows: auto auto auto auto; } .emz-hybrid #MainContent .emz-hybrid-product-lede { text-align: inherit; } }',
    '.emz-inside { padding-block: 56px 60px; border-bottom: 1px solid var(--emz-hybrid-line, #e4d9e9); font-family: var(--typeBasePrimary), var(--typeBaseFallback); text-align: left; }',
    '.emz-inside__header { display: grid; grid-template-columns: minmax(0,1fr) auto; align-items: end; gap: 10px 32px; margin-bottom: 30px; }',
    'html body.emz-hybrid #PageContainer #MainContent .emz-inside .emz-inside__heading { grid-column: 1; margin: 0; font-family: var(--emz-whole-heading-family, var(--typeHeaderPrimary)), var(--typeHeaderFallback) !important; font-weight: var(--emz-whole-heading-weight, var(--typeHeaderWeight)) !important; font-size: clamp(32px,3.2vw,46px); line-height: 1.1; letter-spacing: -.03em !important; text-transform: none; }',
    /* The legacy body/p rule would otherwise set these paragraphs in the storytelling serif. */
    'html body.emz-hybrid #PageContainer #MainContent .emz-inside :is(.emz-inside__intro,.emz-inside__note) { font-family: var(--typeBasePrimary), var(--typeBaseFallback) !important; }',
    '.emz-inside__intro { grid-column: 1; max-width: 560px; margin: 0; color: var(--emz-hybrid-muted, #5f5266); font-size: 15px; line-height: 1.6; }',
    '.emz-inside__full { grid-column: 2; grid-row: 1 / span 2; align-self: end; display: inline-flex; align-items: center; min-height: 44px; font-size: 14px; white-space: nowrap; }',
    'html body.emz-hybrid #PageContainer #MainContent .emz-inside .emz-inside__full { color: var(--emz-hybrid-accent, #50365e); text-decoration: underline; text-underline-offset: 3px; }',
    '.emz-inside__full[hidden] { display: none; }',
    /* Short lists stay compact; three/six entries fill the row without taller photos. */
    '.emz-inside__list { display: grid; grid-template-columns: repeat(4,minmax(0,1fr)); gap: 30px 24px; margin: 0; padding: 0; list-style: none; }',
    '.emz-inside__item { min-width: 0; margin: 0; }',
    '.emz-inside__photos { display: flex; gap: 4px; aspect-ratio: 4 / 5; overflow: hidden; border-radius: var(--emz-card-radius, 22px); background: var(--emz-hybrid-surface, #f4eef7); }',
    '.emz-inside__photo { display: block; flex: 1 1 0; min-width: 0; cursor: pointer; }',
    '.emz-inside__photo img { display: block; width: 100%; height: 100%; object-fit: cover; opacity: 1; transition: opacity .35s ease, transform .5s ease; }',
    '.emz-inside__photo img[data-loading] { opacity: 0; }',
    '.emz-inside__item:hover .emz-inside__photo:not(.emz-inside__photo--artwork) img { transform: scale(1.03); }',
    /* Feature entries can have curated artwork without acquiring a glossary link. */
    '.emz-inside__photos--empty { display: none; }',
    '.emz-inside__photo--artwork { cursor: default; }',
    'html body.emz-hybrid #PageContainer #MainContent .emz-inside .emz-inside__name { margin: 16px 0 6px; font-family: var(--typeBasePrimary), var(--typeBaseFallback) !important; font-size: 17px; font-weight: 600 !important; line-height: 1.35; letter-spacing: normal !important; text-transform: none !important; overflow-wrap: anywhere; }',
    '.emz-inside__name a { color: inherit; text-decoration: underline; text-decoration-thickness: 1px; text-underline-offset: 4px; }',
    '.emz-inside__name a:hover { text-decoration-thickness: 2px; }',
    '.emz-inside :is(a,.emz-inside__list):focus-visible { outline: 3px solid var(--emz-hybrid-accent, #765586); outline-offset: 3px; border-radius: 4px; }',
    '.emz-inside__note { margin: 0; color: var(--emz-hybrid-muted, #5f5266); font-size: 14.5px; line-height: 1.6; }',
    '@media (prefers-reduced-motion: reduce) { .emz-inside__photo img { transition: none; } .emz-inside__item:hover .emz-inside__photo:not(.emz-inside__photo--artwork) img { transform: none; } }',
    '@media (max-width: 989px) and (min-width: 769px) { .emz-inside__list { grid-template-columns: repeat(3,minmax(0,1fr)); } }',
    '@media (min-width: 769px) { .emz-inside__list[data-count="1"] { grid-template-columns: minmax(0,280px); } .emz-inside__list[data-count="2"] { grid-template-columns: repeat(2,minmax(0,280px)); } .emz-inside__list:is([data-count="3"],[data-count="6"]) { grid-template-columns: repeat(3,minmax(0,1fr)); } .emz-inside__list:is([data-count="3"],[data-count="6"]) .emz-inside__photos { width: 100%; max-height: 352px; } }',
    /* Phones: a swipeable row; the next card peeks in and each name link scrolls into view on focus. */
    '@media (max-width: 768px) { .emz-inside { padding-block: 36px 40px; } .emz-inside__header { grid-template-columns: minmax(0,1fr); margin-bottom: 20px; } .emz-inside__full { grid-column: 1; grid-row: auto; justify-self: start; } .emz-inside__list { display: flex; gap: 14px; margin-inline: -17px; padding: 0 17px 6px; overflow-x: auto; overscroll-behavior-x: contain; scroll-snap-type: x mandatory; scroll-padding-inline: 17px; scrollbar-width: none; } .emz-inside__list::-webkit-scrollbar { display: none; } .emz-inside__item { flex: 0 0 min(68%, 280px); scroll-snap-align: start; } .emz-inside__item:only-child { flex-basis: min(100%, 280px); } .emz-inside__photos { aspect-ratio: 1; } }',
    '.emz-inside--compact .emz-inside__list { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 20px; align-items: start; margin: 0; padding: 0; overflow: visible; }',
    '.emz-inside--compact .emz-inside__item { display: grid; grid-template-columns: 120px minmax(0,1fr); gap: 9px 20px; align-items: start; padding: 22px; border-radius: 20px; background: var(--emz-hybrid-surface, #f4eef7); }',
    '.emz-inside--compact .emz-inside__photos { grid-column: 1; grid-row: 1 / span 2; width: 120px; aspect-ratio: 4 / 5; border-radius: 14px; }',
    '.emz-inside--compact :is(.emz-inside__name,.emz-inside__note) { grid-column: 1 / -1; }',
    '.emz-inside--compact .emz-inside__photos:not(.emz-inside__photos--empty) ~ :is(.emz-inside__name,.emz-inside__note) { grid-column: 2; }',
    'html body.emz-hybrid #PageContainer #MainContent .emz-inside--compact .emz-inside__name { margin: 0; font-size: 18px; }',
    '.emz-inside--compact .emz-inside__note { font-size: 15px; line-height: 1.65; }',
    '@media (min-width: 769px) { .emz-inside--compact .emz-inside__item { grid-template-rows: auto 1fr; } }',
    '@media (min-width: 769px) and (max-width: 989px) { .emz-inside--compact .emz-inside__list { grid-template-columns: minmax(0,1fr); } }',
    '@media (max-width: 768px) { .emz-inside--compact .emz-inside__list { grid-template-columns: minmax(0,1fr); gap: 14px; } .emz-inside--compact .emz-inside__item { grid-template-columns: 88px minmax(0,1fr); gap: 14px; padding: 20px; } .emz-inside--compact .emz-inside__photos { width: 88px; aspect-ratio: 1; grid-row: 1; } .emz-inside--compact .emz-inside__photos:not(.emz-inside__photos--empty) ~ .emz-inside__name { align-self: center; } .emz-inside--compact .emz-inside__photos:not(.emz-inside__photos--empty) ~ .emz-inside__note { grid-column: 1 / -1; } .emz-inside--compact .emz-inside__note { font-size: 14.5px; } }',
    '@media (max-width: 359px) { .emz-inside--compact .emz-inside__item { padding: 17px; grid-template-columns: 72px minmax(0,1fr); } .emz-inside--compact .emz-inside__photos { width: 72px; } }'
  ].join('\n');

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = STYLES;
    document.head.appendChild(style);
  }

  function ingredientHandle(link) {
    try {
      var url = new URL(link.getAttribute('href'), window.location.href);
      var match = url.pathname.match(/^\/blogs\/ingredients\/([a-z0-9]+(?:-[a-z0-9]+)*)\/?$/);
      return match && (url.origin === window.location.origin || /(^|\.)emzblendz\.com$/.test(url.hostname)) ? match[1] : null;
    } catch (error) { return null; }
  }

  function readIngredientImages() {
    var data = document.getElementById('ingredient-metaobject-data');
    try {
      var parsed = data && JSON.parse(data.textContent);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (error) { return {}; }
  }

  // What's inside: the product's own Key Ingredients (its authored dl.ingredients-list), in
  // order, each with the ingredient glossary image when the description links one. It reads
  // only this page and the glossary data the ingredient popup already loads; it adds no facts
  // and infers no links. Product-scoped artwork can fill gaps; otherwise text stays compact.
  function buildInside(section, tabs, productId) {
    if (section.getAttribute('data-emz-inside-enabled') === 'false') return null;
    // Kits reuse the same markup for "What's Included"; use the first list (Ingredients tab
    // first) whose entries link the ingredient glossary.
    var candidates = tabs ? Array.from(tabs.querySelectorAll('#emz-tab-ingredients dl.ingredients-list')).concat(Array.from(tabs.querySelectorAll('dl.ingredients-list'))) : [];
    var list = candidates.find(function (dl) {
      return Array.from(dl.querySelectorAll('dt a[href]')).some(function (link) { return ingredientHandle(link); });
    });
    if (!list) return null;
    var entries = [];
    Array.from(list.children).forEach(function (node) {
      if (node.tagName === 'DT') entries.push({ dt: node, dd: null });
      else if (node.tagName === 'DD' && entries.length && !entries[entries.length - 1].dd) entries[entries.length - 1].dd = node;
    });
    entries = entries.filter(function (entry) { return entry.dt.textContent.trim(); }).slice(0, INSIDE_LIMIT);
    var linked = entries.filter(function (entry) {
      entry.handles = [];
      Array.from(entry.dt.querySelectorAll('a[href]')).forEach(function (link) {
        var handle = ingredientHandle(link);
        if (handle && entry.handles.indexOf(handle) === -1) entry.handles.push(handle);
      });
      return entry.handles.length > 0;
    });
    if (!linked.length) return null;

    var band = document.createElement('section');
    band.className = 'emz-inside';
    band.setAttribute('data-emz-inside', '');
    var headingId = 'EmzInside-' + productId;
    band.setAttribute('aria-labelledby', headingId);
    var header = document.createElement('div');
    header.className = 'emz-inside__header';
    var heading = document.createElement('h2');
    heading.className = 'emz-inside__heading';
    heading.id = headingId;
    heading.textContent = (section.getAttribute('data-emz-inside-heading') || '').trim() || 'What’s inside';
    var intro = document.createElement('p');
    intro.className = 'emz-inside__intro';
    intro.textContent = section.getAttribute('data-emz-inside-intro') || 'The key ingredients in this product. Select a linked name to learn more.';
    var full = document.createElement('a');
    full.className = 'emz-inside__full';
    full.href = '#emz-full-ingredients-heading';
    full.hidden = true;
    full.textContent = section.getAttribute('data-emz-inside-full') || 'See the full ingredients list';
    header.append(heading, intro, full);
    var items = document.createElement('ul');
    items.className = 'emz-inside__list';
    items.setAttribute('role', 'list');
    items.setAttribute('data-count', String(entries.length));
    var frames = [];
    var focusFrame = null;
    var featureList = linked.length !== entries.length;
    var artwork = Array.from(section.querySelectorAll('[data-emz-inside-artwork]'));
    var editorMarkers = [];
    function normalizeLabel(value) { return value.replace(/\s+/g, ' ').trim(); }
    function updateLayout() {
      band.classList.toggle('emz-inside--compact', featureList || !!items.querySelector('.emz-inside__photos--empty'));
      updateScroll();
    }

    entries.forEach(function (entry) {
      var item = document.createElement('li');
      item.className = 'emz-inside__item';
      var photos = document.createElement('div');
      photos.className = 'emz-inside__photos';
      photos.setAttribute('aria-hidden', 'true');
      var plate = function () {
        photos.className = 'emz-inside__photos emz-inside__photos--empty';
        photos.replaceChildren();
        updateLayout();
      };
      var label = normalizeLabel(entry.dt.textContent);
      var matches = artwork.filter(function (node) { return normalizeLabel(node.getAttribute('data-label') || '') === label; });
      var uniqueLabel = entries.filter(function (other) { return normalizeLabel(other.dt.textContent) === label; }).length === 1;
      var curated = null;
      if (matches.length === 1 && uniqueLabel) {
        try {
          var url = new URL(matches[0].getAttribute('data-image'), window.location.href);
          if (url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' ||
              (url.origin === window.location.origin && url.pathname.indexOf('/cdn/shop/') === 0))) {
            url.searchParams.delete('width');
            curated = url.href;
          }
        } catch (error) { /* Missing or invalid artwork leaves native images/text intact. */ }
        var marker = matches[0].getAttribute('data-shopify-editor-block');
        if (marker) {
          item.setAttribute('data-shopify-editor-block', marker);
          matches[0].removeAttribute('data-shopify-editor-block');
          editorMarkers.push({ node: matches[0], marker: marker });
        }
      }
      if (entry.handles.length || curated) frames.push({ photos: photos, handles: entry.handles.slice(0, 2), curated: curated, plate: plate });
      else plate();
      var name = document.createElement('h3');
      name.className = 'emz-inside__name';
      // The authored name keeps its own glossary links, which the ingredient popup enhances.
      Array.from(entry.dt.childNodes).forEach(function (child) {
        var copy = child.cloneNode(true);
        if (copy.nodeType === 1) {
          copy.removeAttribute('id');
          Array.from(copy.querySelectorAll('[id]')).forEach(function (node) { node.removeAttribute('id'); });
        }
        name.appendChild(copy);
      });
      item.append(photos, name);
      var noteText = entry.dd && entry.dd.textContent.replace(/\s+/g, ' ').trim();
      if (noteText) {
        var note = document.createElement('p');
        note.className = 'emz-inside__note';
        note.textContent = noteText;
        item.appendChild(note);
      }
      items.appendChild(item);
    });
    band.append(header, items);
    updateLayout();

    // A photo is a pointer target for its ingredient's own name link, so the popup (or
    // article) opens from a visible, focusable control and focus returns there.
    band.addEventListener('click', function (event) {
      var photo = event.target.closest && event.target.closest('.emz-inside__photo');
      if (photo && photo.classList.contains('emz-inside__photo--artwork')) return;
      var item = photo && photo.closest('.emz-inside__item');
      if (!item || event.button !== 0) return;
      var links = Array.from(item.querySelectorAll('.emz-inside__name a[href]'));
      var target = links.find(function (link) { return ingredientHandle(link) === photo.getAttribute('data-handle'); }) || links[0];
      if (!target) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey) window.open(target.href, '_blank', 'noopener');
      else target.click();
    });

    // On phones the row scrolls sideways; while it overflows it is keyboard-scrollable
    // too, so entries without a link can still be reached.
    function updateScroll() {
      if (items.scrollWidth > items.clientWidth + 1) {
        items.tabIndex = 0;
        items.setAttribute('aria-label', heading.textContent);
      } else {
        items.removeAttribute('tabindex');
        items.removeAttribute('aria-label');
      }
      if (items.contains(document.activeElement)) queueIngredientFocus();
    }
    // Native focus scrolling can leave an already partly visible name clipped. Reveal
    // its card in this row only, after the browser's own focus scroll has settled.
    function revealFocusedIngredient() {
      focusFrame = null;
      var link = document.activeElement;
      if (!link || !items.contains(link) || !link.matches('.emz-inside__name a[href]') ||
          band.classList.contains('emz-inside--compact') || items.scrollWidth <= items.clientWidth + 1) return;
      var row = items.getBoundingClientRect();
      var target = link.getBoundingClientRect();
      var clearance = 6; // Include the existing 3px outline and its 3px offset.
      if (target.left >= row.left + clearance && target.right <= row.right - clearance) return;
      var card = link.closest('.emz-inside__item').getBoundingClientRect();
      var styles = window.getComputedStyle(items);
      var padding = parseFloat(styles.scrollPaddingInlineStart) || clearance;
      var rtl = styles.direction === 'rtl';
      var delta = rtl ? card.right - (row.right - padding) : card.left - (row.left + padding);
      items.scrollLeft += delta;
    }
    function queueIngredientFocus() {
      if (focusFrame !== null) window.cancelAnimationFrame(focusFrame);
      focusFrame = window.requestAnimationFrame(revealFocusedIngredient);
    }
    items.addEventListener('focusin', queueIngredientFocus);
    var resizeObserver = null;
    if (typeof ResizeObserver === 'function') {
      resizeObserver = new ResizeObserver(updateScroll);
      resizeObserver.observe(items);
    }

    // Fill photos from the popup's ingredient data. Its single write (success or failure)
    // or data already present is final; unresolved linked frames stay neutral until
    // INSIDE_WAIT, then use curated artwork/text and still accept late native data.
    var data = document.getElementById('ingredient-metaobject-data');
    var observer = null;
    var timer = null;
    function renderPhotos(frame, pairs, curated) {
      frame.photos.replaceChildren();
      frame.photos.className = 'emz-inside__photos';
      pairs.forEach(function (pair) {
        var url = pair.url;
        var join = url.indexOf('?') === -1 ? '?' : '&';
        var link = document.createElement('span');
        link.className = 'emz-inside__photo' + (curated ? ' emz-inside__photo--artwork' : '');
        if (!curated) link.setAttribute('data-handle', pair.handle);
        var image = document.createElement('img');
        image.alt = '';
        image.width = 480;
        image.height = 720;
        image.loading = 'lazy';
        image.decoding = 'async';
        var wideRow = entries.length === 3 || entries.length === 6;
        var split = pairs.length === 2;
        image.sizes = featureList ? '(min-width: 769px) 120px, (min-width: 360px) 88px, 72px' :
          '(min-width: 990px) ' + (wideRow ? (split ? '16vw' : '32vw') : (split ? '140px' : '280px')) + ', (min-width: 769px) ' + (split ? '15vw' : '30vw') + ', ' + (split ? '32vw' : '64vw');
        image.srcset = [280, 480, 720].map(function (width) { return url + join + 'width=' + width + ' ' + width + 'w'; }).join(', ');
        image.src = url + join + 'width=480';
        image.setAttribute('data-loading', '');
        var shown = function () { image.removeAttribute('data-loading'); };
        image.addEventListener('load', shown, { once: true });
        image.addEventListener('error', function () {
          if (link.parentNode !== frame.photos) return;
          link.remove();
          if (!frame.photos.children.length) {
            if (!curated && frame.curated) renderPhotos(frame, [{ url: frame.curated }], true);
            else frame.plate();
          }
        }, { once: true });
        link.appendChild(image);
        frame.photos.appendChild(link);
        if (image.complete && image.naturalWidth) shown();
      });
      updateLayout();
    }
    function settle(written, timedOut) {
      var images = readIngredientImages();
      var final = written || Object.keys(images).length > 0;
      frames = frames.filter(function (frame) {
        var pairs = frame.handles.map(function (handle) {
          var url = images[handle] && images[handle].popup_image;
          return typeof url === 'string' && url.indexOf('https://cdn.shopify.com/') === 0 ? { handle: handle, url: url } : null;
        }).filter(Boolean);
        if (!pairs.length) {
          if (!frame.handles.length || final || timedOut) {
            if (frame.curated) renderPhotos(frame, [{ url: frame.curated }], true);
            else frame.plate();
          }
          return frame.handles.length > 0 && !final;
        }
        renderPhotos(frame, pairs, false);
        return false;
      });
      if ((final || !frames.length) && observer) { observer.disconnect(); observer = null; }
      if ((final || timedOut || !frames.length) && timer) { window.clearTimeout(timer); timer = null; }
    }
    settle(false, false);
    if (frames.length && data && typeof MutationObserver === 'function') {
      observer = new MutationObserver(function () { settle(true, false); });
      observer.observe(data, { childList: true, characterData: true, subtree: true });
      timer = window.setTimeout(function () { settle(false, true); }, INSIDE_WAIT);
    } else if (frames.length) {
      settle(true, false);
    }
    return {
      node: band,
      full: full,
      update: updateScroll,
      release: function () {
        items.removeEventListener('focusin', queueIngredientFocus);
        if (focusFrame !== null) window.cancelAnimationFrame(focusFrame);
        if (observer) observer.disconnect();
        if (timer) window.clearTimeout(timer);
        if (resizeObserver) resizeObserver.disconnect();
        editorMarkers.forEach(function (entry) { entry.node.setAttribute('data-shopify-editor-block', entry.marker); });
        observer = null; timer = null; resizeObserver = null;
      }
    };
  }

  function sectionsWithin(scope) {
    var sections = Array.from(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) sections.unshift(scope);
    return sections;
  }

  // Keep the reading pane on this history entry when following an information link.
  function preserveReadingPane(section, tabs) {
    var productId = section.getAttribute('data-product-id');
    var path = window.location.pathname;
    if (!tabs || !productId || section.getAttribute('data-modal') === 'true' ||
        (window.Shopify && window.Shopify.designMode) || path.indexOf('/products/') === -1 ||
        document.querySelectorAll(selector + ':not([data-modal="true"])').length !== 1) return null;

    function supportedButton(tabId) {
      var button = Array.from(tabs.querySelectorAll('.emz-tab-btn')).find(function (node) {
        return node.getAttribute('aria-controls') === tabId;
      });
      var pane = Array.from(tabs.querySelectorAll('.emz-tab-pane')).find(function (node) {
        return node.id === tabId;
      });
      return button && pane ? button : null;
    }

    try {
      var current = window.history.state;
      var saved = current && current.emzProductReading;
      if (Object.prototype.toString.call(current) === '[object Object]' && saved &&
          saved.productId === productId && saved.path === path) {
        var consumed = Object.assign({}, current);
        delete consumed.emzProductReading;
        window.history.replaceState(consumed, '');
        var navigation = window.performance && window.performance.getEntriesByType &&
          window.performance.getEntriesByType('navigation')[0];
        if (navigation && navigation.type === 'back_forward' && !window.location.hash &&
            !tabs.querySelector('[data-emz-question-response]')) {
          var savedButton = supportedButton(saved.tabId);
          if (savedButton && typeof window.emzOpenTab === 'function') {
            window.emzOpenTab({ currentTarget: savedButton }, saved.tabId);
          }
        }
      }
    } catch (error) { /* Reading remains usable when history is unavailable. */ }

    function remember(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || !tabs.contains(link) || link.hasAttribute('download') ||
          (link.target && link.target !== '_self') || link.origin !== window.location.origin ||
          link.pathname === window.location.pathname) return;
      var button = tabs.querySelector('.emz-tab-btn.active[aria-expanded="true"]');
      var tabId = button && button.getAttribute('aria-controls');
      if (!supportedButton(tabId)) return;
      try {
        var state = window.history.state;
        if (state !== null && Object.prototype.toString.call(state) !== '[object Object]') return;
        var next = Object.assign({}, state);
        next.emzProductReading = { productId: productId, path: path, tabId: tabId };
        window.history.replaceState(next, '');
      } catch (error) { /* The ordinary link remains the fallback. */ }
    }
    tabs.addEventListener('click', remember);
    return function () { tabs.removeEventListener('click', remember); };
  }

  function initialize(section) {
    if (states.has(section)) return;

    var grid = section.querySelector('.emz-hybrid-product-grid');
    var intro = section.querySelector('[data-emz-product-intro]');
    var header = section.querySelector('.product-single__meta > .product-block--header');
    var blocks = section.querySelector('[data-product-blocks]');
    var price = blocks && blocks.querySelector('.product-block--price');
    var media = grid && grid.querySelector('.emz-hybrid-product-media');
    var details = grid && grid.querySelector('.emz-hybrid-product-details');
    if (!grid || !intro || !header || !blocks || !media || !details) return;
    ensureStyles();

    var moves = [];
    var generated = [];
    function move(node, parent, before) {
      var origin = document.createComment('emz-hybrid-origin');
      node.parentNode.insertBefore(origin, node);
      moves.push({ node: node, origin: origin });
      parent.insertBefore(node, before || null);
    }

    move(header, intro);
    // Reading order is name, photograph, then summary/price/Save and decisions for
    // either desktop image side. The price now sits directly above the options,
    // so phones no longer need a sticky price copy that can cover a choice.
    if (media.nextElementSibling !== details) move(media, grid, details);
    var lede = document.createElement('div');
    lede.className = 'emz-hybrid-product-lede';
    grid.insertBefore(lede, details);
    generated.push(lede);
    Array.from(header.querySelectorAll('[data-emz-manual-summary], [data-emz-uploaded-summary]')).forEach(function (summaryNode) {
      if (summaryNode.parentNode === header) move(summaryNode, lede);
    });
    if (price) move(price, lede);
    var save = header.querySelector(':scope > .emz-save-control--product');
    if (save) move(save, lede);

    // Move the existing social block after product information, retaining editor identity.
    // Server markup stays intact for quick view and the existing restore lifecycle.
    var tabs = details.querySelector('.emz-tabs-wrapper');
    var whole = section.getAttribute('data-emz-whole-product') === 'true';
    var information = section.querySelector('[data-emz-whole-information]');
    if (whole && tabs && information) {
      move(tabs, information);
    }
    if (section.getAttribute('data-modal') !== 'true' && tabs) {
      var afterTabs = tabs.nextSibling;
      Array.from(blocks.children).forEach(function (block) {
        if (block.classList.contains('product-block') && block.querySelector('.social-follow')) {
          move(block, tabs.parentNode, afterTabs);
        }
      });
    }

    // Keep native cross-sells after the story and information on every viewport.
    // Move the existing nodes so links, quick-add handlers and editor restoration survive.
    if (whole && tabs && information) {
      var follow = information.querySelector('.social-follow');
      var beforeFollow = follow && follow.closest('.product-block');
      Array.from(details.querySelector('.product-single__meta').children).forEach(function (block) {
        if (block.matches('.emz-closing-tagline, .emz-pairings-section')) {
          move(block, information, beforeFollow);
        }
      });
    }

    // Story previews read the same public description the uploader already supplies.
    // Never read internal maker-notes metafields or fall back to stale copied story text.
    var uploadedStory = section.querySelector('[data-emz-uploaded-story]');
    var uploadedSummary = section.querySelector('[data-emz-uploaded-summary]');
    var sourcePane = tabs && tabs.querySelector('#emz-tab-details');
    var sourceIntro = sourcePane && sourcePane.firstElementChild;
    var sourceBenefits = sourcePane && Array.from(sourcePane.children).find(function (node) {
      return node.classList.contains('rte') && node.querySelector('ul.benefits-list');
    });
    if (sourceIntro && sourceIntro.classList.contains('rte') &&
        !sourceIntro.classList.contains('rte--full-description') &&
        sourceBenefits && sourceBenefits !== sourceIntro) {
      var subheadline = sourceIntro.querySelector('p.product-subheadline');
      var storyParagraph = Array.from(sourceIntro.children).find(function (node) {
        return node.tagName === 'P' && node !== subheadline && node.textContent.trim();
      });
      var makerQuote = sourceIntro.querySelector('blockquote:not(.customer-testimonial)');
      function previewCopy(source, destination) {
        if (!source || !destination || source.querySelector('input,textarea,select,form')) return;
        var copy = source.cloneNode(true);
        copy.removeAttribute('id');
        Array.from(copy.querySelectorAll('[id]')).forEach(function (node) { node.removeAttribute('id'); });
        destination.appendChild(copy);
        generated.push(copy);
      }
      if (uploadedStory && storyParagraph) {
        previewCopy(storyParagraph, uploadedStory.querySelector('[data-emz-uploaded-story-text]'));
        previewCopy(makerQuote, uploadedStory.querySelector('[data-emz-uploaded-story-quote]'));
        uploadedStory.hidden = false;
      }
    }

    // A product's own public subheadline is independent of its optional story block.
    // Explicit markup only: never guess from the title, maker notes or another product.
    var summarySources = sourcePane && sourcePane.querySelectorAll('p.product-subheadline');
    if (uploadedSummary && summarySources && summarySources.length === 1) {
      var summarySource = summarySources[0];
      if (summarySource.textContent.trim() && !summarySource.querySelector('input,textarea,select,form')) {
        var summaryCopy = summarySource.cloneNode(true);
        summaryCopy.removeAttribute('id');
        Array.from(summaryCopy.querySelectorAll('[id]')).forEach(function (node) { node.removeAttribute('id'); });
        uploadedSummary.appendChild(summaryCopy);
        generated.push(summaryCopy);
        uploadedSummary.hidden = false;
      }
    }
    var visibleSummary = uploadedSummary && !uploadedSummary.hidden ? uploadedSummary : section.querySelector('[data-emz-manual-summary]');
    var detailsButton = tabs && tabs.querySelector('.emz-tab-btn[aria-controls="emz-tab-details"]');
    if (visibleSummary && detailsButton && sourcePane) {
      var detailsLink = document.createElement('a');
      detailsLink.className = 'emz-product-details-link';
      detailsLink.href = '#emz-tab-details';
      detailsLink.textContent = 'Explore the details ↓';
      detailsLink.addEventListener('click', function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        detailsButton.click();
        detailsButton.focus({ preventScroll: true });
        tabs.scrollIntoView({ block: 'start', behavior: 'auto' });
      });
      visibleSummary.insertAdjacentElement('afterend', detailsLink);
      generated.push(detailsLink);
    }

    // What's inside sits between shopping and the story in the whole-page layout. It is
    // optional: a failure here must not leave the composed product half built.
    var releaseInside = null;
    var inside = null;
    if (whole && section.getAttribute('data-modal') !== 'true') {
      try {
        inside = buildInside(section, tabs, section.getAttribute('data-product-id') || 'product');
      } catch (error) { inside = null; }
    }
    if (inside) {
      grid.parentNode.insertBefore(inside.node, grid.nextSibling);
      generated.push(inside.node);
      releaseInside = inside.release;
      inside.update();
      // The complete list is offered only where an Ingredients tab exists. It lands on the
      // Full Ingredients List heading when the product has one, as the tab's own link does.
      var ingredientsButton = tabs.querySelector('.emz-tab-btn[aria-controls="emz-tab-ingredients"]');
      if (ingredientsButton) {
        inside.full.addEventListener('click', function (event) {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          ingredientsButton.click();
          var fullHeading = tabs.querySelector('#emz-tab-ingredients #emz-full-ingredients-heading');
          var target = fullHeading || ingredientsButton;
          target.focus({ preventScroll: true });
          (fullHeading || tabs).scrollIntoView({ block: 'start', behavior: 'auto' });
        });
        inside.full.hidden = false;
      }
    }

    // Enhance only the structured description produced by the existing tab parser.
    // Unknown/full-description formats remain completely visible.
    if (whole && tabs) {
      var pane = tabs.querySelector('#emz-tab-details');
      var introCopy = pane && pane.firstElementChild;
      var benefits = pane && Array.from(pane.children).find(function (node) {
        return node.classList.contains('rte') && node.querySelector('ul.benefits-list');
      });
      var opening = introCopy && introCopy.firstElementChild;
      if (introCopy && introCopy.classList.contains('rte') &&
          !introCopy.classList.contains('rte--full-description') &&
          benefits && benefits !== introCopy && opening && opening.tagName === 'P' &&
          opening.textContent.trim().length > 0 && opening.textContent.trim().length < 450) {
        var tail = Array.from(introCopy.childNodes).slice(Array.from(introCopy.childNodes).indexOf(opening) + 1);
        // Authored notices remain visible; only optional narrative goes into the story.
        tail = tail.filter(function (node) {
          return node.nodeType !== 1 || (!node.matches('.warning-notice, .product-selection-note') && !node.querySelector('.warning-notice, .product-selection-note'));
        });
        var tailLength = tail.map(function (node) { return node.textContent; }).join('').trim().length;
        if (tailLength > 250) {
          var continuation = Array.from(pane.children).find(function (node) {
            return node.classList.contains('emz-sampler-continuation');
          });
          var continuationDivider = continuation && continuation.previousElementSibling;
          if (continuationDivider && (continuationDivider.tagName !== 'HR' || !continuationDivider.classList.contains('emz-tab-section-divider'))) continuationDivider = null;
          var kitContents = Array.from(pane.children).find(function (node) {
            return node.classList.contains('emz-kit-contents');
          });
          var kitDivider = kitContents && kitContents.previousElementSibling;
          if (kitDivider && (kitDivider.tagName !== 'HR' || !kitDivider.classList.contains('emz-tab-section-divider'))) kitDivider = null;
          var later = [];
          var next = benefits.nextSibling;
          while (next) {
            if (next !== continuation && next !== continuationDivider && next !== kitContents && next !== kitDivider) later.push(next);
            next = next.nextSibling;
          }
          var disclosure = document.createElement('details');
          disclosure.className = 'emz-details-story';
          var summary = document.createElement('summary');
          summary.textContent = 'Read the full story';
          disclosure.appendChild(summary);
          var storyBody = document.createElement('div');
          storyBody.className = 'emz-details-story-body';
          var narrative = document.createElement('div');
          narrative.className = 'rte';
          storyBody.appendChild(narrative);
          disclosure.appendChild(storyBody);
          pane.insertBefore(disclosure, continuationDivider || continuation || null);
          generated.push(disclosure);
          tail.forEach(function (node) { move(node, narrative); });
          later.forEach(function (node) { move(node, storyBody); });
        }
      }
    }

    var releaseReadingPane = preserveReadingPane(section, tabs);
    states.set(section, { moves: moves, generated: generated, releaseReadingPane: releaseReadingPane, releaseInside: releaseInside });
    intro.hidden = false;
    section.classList.add('emz-hybrid-product-ready');
  }

  function restore(section) {
    var state = states.get(section);
    if (!state) return;
    if (state.releaseReadingPane) state.releaseReadingPane();
    if (state.releaseInside) state.releaseInside();
    state.moves.forEach(function (move) {
      if (move.origin.parentNode) {
        move.origin.parentNode.insertBefore(move.node, move.origin);
        move.origin.remove();
      }
    });
    state.generated.forEach(function (node) { node.remove(); });
    Array.from(section.querySelectorAll('[data-emz-uploaded-story], [data-emz-uploaded-summary]')).forEach(function (node) { node.hidden = true; });
    var intro = section.querySelector('[data-emz-product-intro]');
    if (intro) intro.hidden = true;
    section.classList.remove('emz-hybrid-product-ready');
    states.delete(section);
  }

  function initializeWithin(scope) {
    sectionsWithin(scope).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    }, { once: true });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    sectionsWithin(event.target).forEach(restore);
  });
}());
